import axios from 'axios'
import gaEvent from 'utilities/tracking'
import { API_ADDRESS_CHECK_URL, ADDRESS_CLARIFICATION } from 'containers/Checkout/constants'
import { API_RESPONSE_AVAILABLE, POLL_INTERVAL, GA_EVENT_CATEGORY } from './constants'

export const ADDRESS_CHECK_INIT = 'ADDRESS_CHECK_INIT'
export const ADDRESS_CHECK_ERROR = 'ADDRESS_CHECK_ERROR'
export const ADDRESS_CHECK_FAILED = 'ADDRESS_CHECK_FAILED'
export const ADDRESS_CHECK_SUCCESS = 'ADDRESS_CHECK_SUCCESS'
export const ADDRESS_CHECK_MULTIPLE = 'ADDRESS_CHECK_MULTIPLE'
export const ADDRESS_CHECK_TASK_QUEUED = 'ADDRESS_CHECK_TASK_QUEUED'

function addressCheckInit() {
  return { type: ADDRESS_CHECK_INIT }
}

function addressCheckSuccess(
  nextStage,
  askLandline,
  appointmentRequired,
  installAddress,
  serviceClass,
  productFeatureAvailability
) {
  return {
    type: ADDRESS_CHECK_SUCCESS,
    payload: {
      nextStage,
      askLandline,
      appointmentRequired,
      installAddress,
      serviceClass,
      productFeatureAvailability,
    },
  }
}

function addressCheckFailed(reason, date) {
  return { type: ADDRESS_CHECK_FAILED, payload: { reason, date } }
}

function addressCheckError() {
  return { type: ADDRESS_CHECK_ERROR }
}

function taskInQueue() {
  return { type: ADDRESS_CHECK_TASK_QUEUED }
}

function addressCheckMultiple(addresses, nextStage) {
  return {
    type: ADDRESS_CHECK_MULTIPLE,
    payload: { addresses, nextStage },
  }
}

const trackEvent = (action, label) => gaEvent(action, {
  event_category: GA_EVENT_CATEGORY,
  event_label: label,
})

function parseAddressCheckResult(data) {
  if (data.next === ADDRESS_CLARIFICATION) {
    return addressCheckMultiple(data.addresses, data.next)
  }
  if (data.reason === API_RESPONSE_AVAILABLE) {
    return addressCheckSuccess(
      data.next,
      data.ask_landline,
      data.appointment_required,
      data.install_address,
      data.service_class,
      data.product_feature_availability
    )
  }

  // Kogan internet not available
  trackEvent('Failed', data.reason || 'unknown')
  return addressCheckFailed(data.reason, data.date)
}

export function checkAddressPoll() {
  return (dispatch) => {
    axios
      .get(API_ADDRESS_CHECK_URL)
      .then((response) => {
        if (response.data.success) {
          if (response.data.pending) {
            // Still pending, try again later
            setTimeout(() => dispatch(checkAddressPoll()), POLL_INTERVAL)
            if (!response.data.started) {
              // Check if its even started, if not, show the additional message
              dispatch(taskInQueue())
            }
          } else {
            // Done! now parse the result
            dispatch(parseAddressCheckResult(response.data))
            const label = response.data.next === ADDRESS_CLARIFICATION ? ADDRESS_CLARIFICATION : API_RESPONSE_AVAILABLE
            trackEvent('Success', label)
          }
        } else {
          dispatch(addressCheckError())
        }
      })
      .catch((error) => {
        dispatch(addressCheckError())
        trackEvent('Error', (error.response && error.response.statusText) || 'client_network')
      })
  }
}

export function checkAddress() {
  return (dispatch) => {
    dispatch(addressCheckInit())
    axios
      .post(API_ADDRESS_CHECK_URL)
      .then((response) => {
        if (response.data.success === false) {
          dispatch(addressCheckError())
        } else if (response.data.pending) {
          // In queue, show loading message
          setTimeout(() => dispatch(checkAddressPoll()), POLL_INTERVAL)
        } else {
          // Wow, that was quick, it was already finished
          dispatch(parseAddressCheckResult(response.data))
          const label = response.data.next === ADDRESS_CLARIFICATION ? ADDRESS_CLARIFICATION : API_RESPONSE_AVAILABLE
          trackEvent('Success', label)
        }
      })
      .catch((error) => {
        dispatch(addressCheckError())
        trackEvent('Error', (error.response && error.response.statusText) || 'client_network')
      })
  }
}



// WEBPACK FOOTER //
// ./containers/stages/AddressCheckStage/actions.js